import { FC } from "react";
import { Text } from "~/components/text";
import { isDev } from "~/shared/constants/Environment";
import { LoadingSpinner } from "./LoadingSpinner";

interface GlobalLoadingProps {
  label: string;
}

export const GlobalLoading: FC<GlobalLoadingProps> = ({ label }) => {
  return (
    <div
      className="fixed inset-0 z-[9999] flex select-none items-center justify-center bg-white"
      data-testid="global-loading"
    >
      <div
        role="status"
        aria-label={label}
        className="flex flex-col items-center gap-4"
      >
        <LoadingSpinner size="xl" />

        {isDev && (
          <Text as="p" variant="muted" className="font-semibold">
            {label}
          </Text>
        )}
      </div>
    </div>
  );
};
